<template>
  <span class="pending-approval-hint">
    <slot></slot>
    <span v-if="summary && !compact" class="pending-approval-hint__summary">{{ summary }}</span>
    <el-tooltip
      v-if="summary"
      :content="summary"
      effect="dark"
      placement="top"
      popper-class="pending-approval-hint-popper"
    >
      <button
        :aria-label="summary"
        class="pending-approval-hint__trigger"
        type="button"
      >
        <i aria-hidden="true" class="el-icon-info"></i>
      </button>
    </el-tooltip>
  </span>
</template>

<script>
import {formatPendingApproval} from '../../utils/pendingApproval'

/**
 * 待审批状态提示：默认展示责任人摘要；紧凑列表仅保留状态和说明图标。
 */
export default {
  name: 'PendingApprovalHint',
  props: {
    info: {
      type: Object,
      default: null,
    },
    // 列表窄单元格仅保留图标提示，避免完整审批说明把整行撑高。
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    summary() {
      return formatPendingApproval(this.info)
    },
  },
}
</script>

<style scoped>
.pending-approval-hint {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  vertical-align: middle;
}

.pending-approval-hint__summary {
  color: #805500;
  font-size: 12px;
  line-height: 1.5;
  white-space: normal;
}

.pending-approval-hint__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  color: #0057B7;
  background: transparent;
  cursor: help;
}

.pending-approval-hint__trigger:hover {
  color: #00448f;
  background: rgba(0, 87, 183, 0.08);
}

.pending-approval-hint__trigger:focus-visible {
  outline: 2px solid #0057B7;
  outline-offset: 2px;
}
</style>

<style>
/* 多角色、多审核人提示限制在可读宽度内，避免悬浮层横跨整个后台页面。 */
.pending-approval-hint-popper {
  max-width: 420px;
  line-height: 1.6;
  white-space: normal;
  word-break: break-word;
}
</style>
